import { render, staticRenderFns } from "./InviteLink.vue?vue&type=template&id=0fcdc748&scoped=true&"
import script from "./InviteLink.vue?vue&type=script&lang=js&"
export * from "./InviteLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcdc748",
  null
  
)

export default component.exports